import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,

};

export const validateURLSession = createAsyncThunk(
  "appleUrl/validateURLSession",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`validate-apple-pay-session`,params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const apple_pay = createAsyncThunk(
  "appleUrl/apple_pay",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`apple-pay`,params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const applePaySlice = createSlice({
  name: "appleUrl",
  initialState,
  reducers: {},
  extraReducers: {
    [validateURLSession.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [validateURLSession.fulfilled]: (state, action) => {
      state.status = "succeeded";
    },
    [validateURLSession.rejected]: (state, action) => {
      state.status = "failed";
    },

    [apple_pay.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [apple_pay.fulfilled]: (state, action) => {
      state.status = "succeeded";
    },
    [apple_pay.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default applePaySlice.reducer;
